export const ALLOWED_CHARACTERS = 
[
    `a`,
    `b`,
    `c`,
    `d`,
    `e`,
    `f`,
    `g`,
    `h`,
    `i`,
    `j`,
    `k`,
    `l`,
    `m`,
    `n`,
    `o`,
    `p`,
    `q`,
    `r`,
    `s`,
    `t`,
    `u`,
    `v`,
    `w`,
    `x`,
    `y`,
    `z`,
    `A`,
    `B`,
    `C`,
    `D`,
    `E`,
    `F`,
    `G`,
    `H`,
    `I`,
    `J`,
    `K`,
    `L`,
    `M`,
    `N`,
    `O`,
    `P`,
    `Q`,
    `R`,
    `S`,
    `T`,
    `U`,
    `V`,
    `W`,
    `X`,
    `Y`,
    `Z`,
    `0`,
    `1`,
    `2`,
    `3`,
    `4`,
    `5`,
    `6`,
    `7`,
    `8`,
    `9`,
    `/`,
    `*`,
    `-`,
    `+`,
    `²`,
    `³`,
    `&`,
    `~`,
    `#`,
    `{`,
    `}`,
    `[`,
    `]`,
    `@`,
    `<`,
    `>`,
    `"`,
    `'`,
    `(`,
    `)`,
    `-`,
    `_`,
    ` `,
    `\n`,
    `\r`,
    `\r\n`,
    `/`,
    `=`,
    `,`,
    `?`,
    `;`,
    `.`,
    `:`,
    `!`,
    `°`,
    `%`,
    `$`,
    `£`,
    `€`,
    `Á`,
    `á`, 
    `À`, 
    `à`, 
    `Â`, 
    `â`, 
    `Ä`, 
    `ä`, 
    `Ã`, 
    `ã`, 
    `Ç`, 
    `ç`, 
    `É`, 
    `é`, 
    `È`, 
    `è`, 
    `Ê`, 
    `ê`, 
    `Ë`, 
    `ë`,
    `Î`, 
    `î`, 
    `Ï`, 
    `ï`, 
    `Í`, 
    `í`, 
    `Ì`, 
    `ì`, 
    `Ó`, 
    `ó`, 
    `Ò`, 
    `ò`, 
    `Ô`, 
    `ô`, 
    `Ö`, 
    `ö`,
    `Œ`, 
    `œ`,
    `Ú`, 
    `ú`, 
    `Ù`, 
    `ù`, 
    `Û`, 
    `û`, 
    `Ü`, 
    `ü`,
    `ů`,
    `Ý`, 
    `ý`
]